import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

// import urlJoin from "url-join";

const ProductStocksSection = "/reports/omi/product-stocks";

export const ProductStocksListPath = ProductStocksSection;

export enum ProductStocksListUrlFiltersEnum {
  query = "query",
  updateFrom = "updateFrom",
  updateTo = "updateTo",
  stockUpdateFrom = "stockUpdateFrom",
  stockUpdateTo = "stockUpdateTo",
  trackInventory = "trackInventory"
}

export enum ProductStocksListUrlFiltersWithMultipleValues {
  mall = "mall",
  brand = "brand",
  productStatus = "productStatus",
  vertical = "vertical"
}
export type ProductStocksListUrlDialog =
  | "add"
  | "view-store"
  | "assign"
  | "download"
  | TabActionDialog;
export type ProductStocksListUrlFilters = Filters<
  ProductStocksListUrlFiltersEnum
> &
  FiltersWithMultipleValues<ProductStocksListUrlFiltersWithMultipleValues>;

export type ProductStocksListUrlQueryParams = ActiveTab &
  ProductStocksListUrlFilters &
  BulkAction &
  Dialog<ProductStocksListUrlDialog> &
  Pagination &
  SingleAction;

export const ProductStocksListUrl = (
  params?: ProductStocksListUrlQueryParams
) => ProductStocksListPath + "?" + stringifyQs(params);
